import * as React from 'react';
import {
  AlignItems,
  Box,
  BoxProps,
  Display,
  FlexDirection,
  JustifyContent,
} from '@gousto-internal/citrus-react';

type FeaturesColumnProps = {
  children: React.ReactNode;
} & Omit<BoxProps, 'children' | 'display' | 'flexDirection'>;

export function FeaturesColumn(props: FeaturesColumnProps) {
  const {
    children,
    paddingH = [6, null, 16],
    paddingV = [14, null, 16],
    maxWidth = [null, null, '550px'],
    alignItems = AlignItems.Center,
    ...boxProps
  } = props;

  return (
    <Box
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      justifyContent={JustifyContent.Center}
      paddingH={paddingH}
      paddingV={paddingV}
      alignItems={alignItems}
      {...boxProps}
    >
      <Box style={{ justifySelf: 'center' }} maxWidth={maxWidth}>
        {children}
      </Box>
    </Box>
  );
}
